import { SettingsItemTextField } from '@elipssolution/harfang';
import { Control, Controller } from 'react-hook-form';

import { DefaultFormType, TextFieldType } from '../../types/form';

type TextFieldFormFieldProps = {
	control: Control<DefaultFormType>;
	specificField: TextFieldType;
};

const TextFieldFormField = ({
	control,
	specificField: { key, name, description, label, rules },
}: TextFieldFormFieldProps) => {
	const { required, pattern } = rules || {};

	return (
		<Controller
			key={key}
			name={name}
			control={control}
			render={({ field: { value, ...field } }) => (
				<SettingsItemTextField
					{...field}
					value={value as string}
					description={description}
					label={label}
					required={!!required}
				/>
			)}
			rules={{
				required: !!required,
				pattern,
			}}
		/>
	);
};

export default TextFieldFormField;
